function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "512244b3bb"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 37.5 37.5 L 337.5 37.5 L 337.5 337.5 L 37.5 337.5 Z M 37.5 37.5 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "912a4d3b70"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 187.5 37.5 C 104.65625 37.5 37.5 104.65625 37.5 187.5 C 37.5 270.34375 104.65625 337.5 187.5 337.5 C 270.34375 337.5 337.5 270.34375 337.5 187.5 C 337.5 104.65625 270.34375 37.5 187.5 37.5 Z M 187.5 37.5 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "7c2d48267a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 138.195312 128.441406 L 234.945312 128.441406 L 234.945312 246.191406 L 138.195312 246.191406 Z M 138.195312 128.441406 ",
  clipRule: "nonzero"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#512244b3bb)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#912a4d3b70)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00f882",
  d: "M 37.5 37.5 L 337.5 37.5 L 337.5 337.5 L 37.5 337.5 Z M 37.5 37.5 ",
  fillOpacity: 1,
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "butt",
  transform: "matrix(0.75, 0, 0, 0.75, 37.500002, 37.499998)",
  fill: "none",
  strokeLinejoin: "miter",
  d: "M 200.00001 0.00000328333 C 89.54167 0.00000328333 -0.00000271667 89.541676 -0.00000271667 200.000016 C -0.00000271667 310.458357 89.54167 400.00003 200.00001 400.00003 C 310.458351 400.00003 400.000024 310.458357 400.000024 200.000016 C 400.000024 89.541676 310.458351 0.00000328333 200.00001 0.00000328333 Z M 200.00001 0.00000328333 ",
  stroke: "#ffffff",
  strokeWidth: 36,
  strokeOpacity: 1,
  strokeMiterlimit: 4
})));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#7c2d48267a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 186.546875 128.441406 L 138.226562 149.917969 L 138.226562 182.128906 C 138.226562 224.167969 172.796875 243.796875 186.546875 246.554688 C 200.296875 243.796875 234.867188 224.167969 234.867188 182.128906 L 234.867188 149.917969 Z M 186.546875 140.199219 L 224.128906 156.902344 L 224.128906 182.128906 C 224.128906 215.0625 198.4375 231.816406 186.546875 235.484375 C 174.65625 231.816406 148.964844 215.0625 148.964844 182.128906 L 148.964844 156.902344 Z M 212.28125 164.921875 L 181.179688 196.015625 L 166.300781 181.132812 L 158.707031 188.726562 L 181.179688 211.199219 L 219.859375 172.503906 Z M 212.28125 164.921875 ",
  fillOpacity: 1,
  fillRule: "nonzero"
}));
function SvgIcono3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcono3);
export default __webpack_public_path__ + "static/media/icono3.8c80d1ea054d7ac6cb2a0a0ba7e8d4d5.svg";
export { ForwardRef as ReactComponent };